import { CaretDownFilled, CaretUpFilled } from '@ant-design/icons'
import { Texto } from '@gravitate-js/excalibrr'
import { Sparklines, SparklinesCurve } from 'react-sparklines'
import React from 'react'

export const GridSparkline = ({ data }) => {
  return (
    <div className='flex items-end justify-end'>
      <Sparklines data={data.sparkline}>
        <SparklinesCurve color={data.sparklineDifference > 0 ? 'green' : 'red'} />
      </Sparklines>

      <Texto category='label' appearance={data.sparklineDifference > 0 ? 'success' : 'error'} weight={600}>
        {data.sparklineDifference > 0 ? <CaretUpFilled className='pl-2' /> : <CaretDownFilled className='pl-2' />}
        {data.sparklineDifference > 0 ? '+' : ''} {data.sparklineDifference.toFixed(2)}%
      </Texto>
    </div>
  )
}
